<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <circle
      style="opacity:0.5; fill:#231f20; stroke:#231f20; stroke-miterlimit:10; stroke-width:2px;"
      cx="32"
      cy="29.96"
      r="20.25"
    />
    <circle
      style="fill:#116c99; stroke:#fff; stroke-miterlimit:10; stroke-width:4px;"
      cx="32"
      cy="32.2"
      r="28"
    />
  </svg>
</template>

<script>
export default {
  name: 'PortfolioFlatIcon',
};
</script>
